<template>
  <div class="_voice">
    <div><img class="_microphone" :src="microphonePng" />
      <div class="_volumeAnimation"></div>
    </div>
  </div>
</template>

<script>
import microphonePng from '@/assets/images/wxyy/microphone.png'
export default {
  name: 'ipsosWxYy',
  props: {},
  data () {
    return {
      microphonePng
    }
  },
  computed: {},
  methods: {},
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
  @keyframes _progress {
    0% {
      background-image: url(~@/assets/images/wxyy/progress01.png);
    }

    12.5% {
      background-image: url(~@/assets/images/wxyy/progress02.png);
    }

    25% {
      background-image: url(~@/assets/images/wxyy/progress03.png);
    }

    37.5% {
      background-image: url(~@/assets/images/wxyy/progress04.png);
    }

    50% {
      background-image: url(~@/assets/images/wxyy/progress05.png);
    }
    62.5% {
      background-image: url(~@/assets/images/wxyy/progress06.png);
    }
    75% {
      background-image: url(~@/assets/images/wxyy/progress07.png);
    }
    87.5% {
      background-image: url(~@/assets/images/wxyy/progress08.png);
    }
    100% {
      background-image: url(~@/assets/images/wxyy/progress01.png);
    }
  }

  ._voice {
    background-color: rgba(0, 0, 0, 0.5);
    display: inline-block;
    position: fixed;
    z-index: 999;
    width: 120px;

    height: 150px;
    top: 50%;
    transform: translateY(-50%);
    left: 0px;
    right: 0px;
    margin-left: auto;
    margin-right: auto;
  }

  ._voice > div {
    display: inline-block;
    text-align: center;
    width: 100%;
  }

  ._voice span {
    text-align: center;
    width: 100%;
    display: block;
    color: #fff;
    font-size: 10px;
  }

  ._voice ._microphone {
    width: 50px;
    height: 99px;
    margin-top: 15px;
    margin-left: 20px;
  }

  ._volumeAnimation {
    animation: _progress 1s infinite;
    -webkit-animation: _progress 3s infinite;
    -webkit-animation-timing-function: steps(1, end);
    animation-timing-function: steps(1, end);
    width: 20px;
    height: 99px;
    background-image: url(~@/assets/images/wxyy/progress01.png);
    background-size: 100%;
    background-position-y: 100%;
    background-repeat: no-repeat;
    text-align: unset;
    display: inline-block;
    margin-bottom: 9px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/plugin/element/ipsosWxYy.vue